import { create } from "zustand";

export const useStoreCRMGetRecords = create((set, get) => ({
  crmRecords: [],

  // Set payload
  setCRMRecords: (data) => {
    set({
      crmRecords: data,
    });
  },

  // ✅ Get specific record by ID
  getCRMRecordById: (id) => {
    const state = get();
    return state.crmRecords.find(
      (item) =>
        item.person_id === id || item.contact_id === id || item.recordId === id || item.organization_id === id
    );
  },
}));
